import useTenantDomain from '@/hooks/useTenantDomain';
import { useSupportContactInformationQuery } from '@/lib/graphql';

interface SupportInfo {
  supportEmail: string | undefined;
}

/** This hook wraps support and contact data for the tenant and current program  */
const useSupportInfo = (): SupportInfo => {
  const { domain } = useTenantDomain();
  const { data } = useSupportContactInformationQuery({
    variables: {
      tenantDomain: domain!,
    },
    skip: !domain,
  });

  return {
    supportEmail: data?.tenant?.supportEmail,
  };
};

export default useSupportInfo;
